
define('text!modules/media/templates/header.html',[],function () { return '<div class="basic-info">\n\t<div class="info">\n\t\t<div class="subtitle">\n\t\t\t<strand-header size="normal">{{subTitle}}</strand-header>\n\t\t</div>\n\t\t<div class="title test">\n\t\t\t<strand-header size="medium">{{title}}</strand-header>\n\t\t</div>\n\t</div>\n</div>\n';});

